<script>

const apiSrc = "https://enjoykaohsiung.thinker.tw";
const subDirectory = "/Platform";
const tripPlanningHost = "https://qa-citygpt.foxconn.com/ibusweb";

//const apiSrc = "https://men-go.tw";
//const subDirectory = "/Platform";
//const tripPlanningHost = "https://ibusplus.tbkc.gov.tw";

//const apiSrc = "https://localhost:44320";
//const subDirectory = "";
//const tripPlanningHost = "https://qa-citygpt.foxconn.com/ibusweb";

const QRCId = 31;
const localVer = "20261020.01.DEBUG";
export default {
  apiSrc,
  subDirectory,
  localVer,
  QRCId,
  tripPlanningHost
};
</script>



// WEBPACK FOOTER //
// src/components/Global.vue